import {
    clientRoute,
    loginRedirectByRole as loginRedirectByRoleFromICS,
    CurrentUserStore as CurrentUserStoreInj,
    rolePriorities as rolePrioritiesFromICS,
} from '@platform/ics-front-core';
import { injectable } from 'react-magnetic-di';
import { RedirectByRole, RolePriority } from '../../types';

export const loginRedirectByRole: RedirectByRole = {
    ...loginRedirectByRoleFromICS,
    Volunteer: clientRoute.campaigns,
    Assistant: clientRoute.campaigns,
};

export const rolePriorities: RolePriority = {
    ...rolePrioritiesFromICS,
    Volunteer: 4,
    Assistant: 5,
};

export class CurrentUserStore extends CurrentUserStoreInj {
    getRolePriorities(): RolePriority {
        return rolePriorities;
    }

    getLoginRedirectByRole(): RedirectByRole {
        return loginRedirectByRole;
    }
}

export const CurrentUserStoreDI = injectable(CurrentUserStoreInj, CurrentUserStore);
